import { render, staticRenderFns } from "./OnboardingSignupForm.vue?vue&type=template&id=536a3d1a&"
import script from "./OnboardingSignupForm.vue?vue&type=script&lang=js&"
export * from "./OnboardingSignupForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports